import { Currency } from "./currency";
import { LanguageCode } from "./languages/types";

export const formatCurrency = (
  value: number,
  currency: Currency,
  language: LanguageCode
): string =>
  Math.trunc(value).toLocaleString(language, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
